import { axios, base, refreshToken, saveRefreshtime } from '../http';

export { refreshToken, saveRefreshtime };

export const requestLogin = (params) => {
  return axios
    .get(`${base}/api/login/jwttoken3.0`, { params: params })
    .then((res) => res.data);
};

/** 获取后台手机号登录开关。 */
export const getSmsLoginOptions = () => {
  return axios.get(`${base}/api/login/sms/options`).then((res) => res.data);
};

/** 发送后台手机号登录验证码。 */
export const sendSmsLoginCode = (params) => {
  return axios.post(`${base}/api/login/sms/send`, params).then((res) => res.data);
};

/** 使用后台手机号验证码登录。 */
export const requestSmsLogin = (params) => {
  return axios.post(`${base}/api/login/sms/token`, params).then((res) => res.data);
};

/** 发送忘记密码重置验证码。 */
export const sendSmsResetPasswordCode = (params) => {
  return axios.post(`${base}/api/login/sms/reset/send`, params).then((res) => res.data);
};

/** 验证绑定手机号后重置后台密码。 */
export const requestResetPasswordBySms = (params) => {
  return axios.post(`${base}/api/login/sms/reset/password`, params).then((res) => res.data);
};

export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data);
};

const clearAuthStorage = () => {
  store.commit("saveToken", "");
  store.commit("saveTokenExpire", "");
  store.commit("saveTagsData", "");
  window.localStorage.removeItem("user");
  window.localStorage.removeItem("NavigationBar");
};

const ToLogin = (params) => {
  clearAuthStorage();

  // 大屏等独立公开页：清掉残留 token 即可，不应出现登录页
  if (isPublicStandaloneRoute(router.currentRoute)) {
    return;
  }

  if (global.IS_IDS4) {
    applicationUserManager.login();
  } else {
    router.replace({
      path: "/login",
      query: { redirect: router.currentRoute.fullPath },
    });
    //window.location.reload()
  }
};

export const getUserByToken = (params) => {
  return axios
    .get(`${base}/api/user/getInfoByToken`, { params: params })
    .then((res) => res.data);
};

export function testapi2() {
  console.log("api is ok.");
}

export const testapi = (pa) => {
  console.log("api is ok.");
};

// 用户管理
